export default __webpack_public_path__ + "static/media/pt-girl.975b260e.webp";